<button
  type="button"
  class="add-question-button"
  (click)="handleAdd()"
  [disabled]="disabled()"
  aria-label="Add new question">
  <i class="pi pi-plus-circle"></i>
</button>

